import _ from 'lodash';
import $ from 'jquery';
import angular from 'angular';
import { Recruiter } from '../components/core/route/recruiterService';


export const templateType = {
    insightTemplates: 'insightTemplates',
    profileCandidate: 'profileCandidate',
    feedbackEmployer: 'feedbackEmployer',
    profileEmployer: 'profileEmployer',
    profilesEmployer: 'profilesEmployer',
    contactCandidateMessage: 'contactCandidateMessage',
    contactCandidateEmail: 'contactCandidateEmail',
    scrapeTemplate: 'scrapeTemplate',
    completeJobDefinition: 'completeJobDefinition',
    shareJobCalibration: 'shareJobCalibration',
    incompleteFetching: 'incompleteFetching',
    toggleAutoContact: 'toggleAutoContact',
    cancelPosition: 'cancelPosition',
    backToReview: 'backToReview',
    publicPositionNotifications: 'publicPositionNotifications',
    contactCandidateLinkedinInmail: 'contactCandidateLinkedinInmail',
    contactCandidateFacebook: 'contactCandidateFacebook',
    campaignsEmployer: 'campaignsEmployer',
    creditsEmployer: 'creditsEmployer',
    ratingIndications: 'ratingIndications',
    inviteEmployerRep: 'inviteEmployerRep',
    inviteEmployerRepByTE: 'inviteEmployerRep_BYTE',
    inviteEmployerRepByEmpRep: 'inviteEmployerRep_BYEMPREP',
};

export const templateName = {
    INTEREST_CANDIDATES_NOTIFCATION: 'Interest Candidates Notifcation',
    SEND_CANDIDATE_BACK_TO_REVIEW_NOTIFICATION: 'Candidate Back to Review',
    SEND_CANDIDATES_BACK_TO_REVIEW_NOTIFICATION: 'Bulk Back to Review',
    JOB_CANCELLED_NOTIFICATION: 'Job Cancelled',
    START_AUTO_CONTACT: 'startAutoContact',
    STOP_AUTO_CONTACT: 'stopAutoContact',
    PROFILE_SUBMISSION: 'Profile Submission (Single profile)',
    CREDIT_USAGE_TURN_OFF: 'Credit usage turn off',
    CREDIT_USAGE_TURN_ON: 'Credit usage turn on',
    REMAINING_CREDIT_BALANCE: '%Remaining Credit balance',
    ZERO_CREDIT_BALANCE: '0 Credit balance',
    CREDIT_BALANCE_UPDATE: 'Credit balance update',
    AUTO_CONTACT_CAMPAIGN_PAUSED: 'Auto contact campaign paused',
    AUTO_CONTACT_CAMPAIGN_RESUMED: 'Auto contact campaign resumed',
    REJECTION_REASON_OTHER: 'Rejection reason Other',
    EMPLOYER_WELCOME_MESSAGE: 'Employer welcome message',
    INVITE_TEMPLATE_TE_1: 'Invite template TE 1',
    RE_INVITE_TEMPLATE_TE_1: 'Re invite template TE 1',
    INVITE_TEMPLATE_EMPREP_1: 'Invite template EMPREP 1',
    RE_INVITE_TEMPLATE_EMPREP_1: 'Re invite template EMPREP 1',
};

export function EmailService(RouteService, CommonCodeService, EnvSettings) {
    const getEmailDataFromRecruiterData = (recruiter = {}) => {
        if (!recruiter) {
            return null;
        }

        const { contact, fullName } = recruiter;
        const email = Recruiter.getEmail(recruiter);
        const phone = getPhoneFromContactData(contact);

        return {
            email,
            phone,
            fullName,
            name: 'talentExperts',
        };
    };

    const getPhoneFromContactData = (contactData = {}) => {
        const phones = _.get(contactData, 'phone');

        if (!phones || phones.length === 0) {
            return null;
        }

        return phones[0].value;
    };

    const sendEmail = ({ from, to, subject, body, bcc }) => RouteService.sendContactCandidateMail({
        subject,
        body,
        from: from.name,
        to,
        bcc,
        talentExpertName: from.fullName,
        talentExpertEmail: from.email,
        talentExpertCellPhone: from.phone,
    });

    const getTextWithLinks = (sourceText) => {
        const linkRegex = /<a href=\\?['"]([\w:/\d\-?&=.]*)\\?['"]>/;
        const linkEndRegex = /<\/a>/;

        let resultText = sourceText;
        let linkValueResult = linkRegex.exec(resultText);
        let linkCloseTagResult = linkEndRegex.exec(resultText);

        while (linkValueResult) {
            const linkValue = linkValueResult[1];
            const linkStartIndex = linkValueResult.index;
            const linkEndIndex = linkCloseTagResult.index + 4;

            resultText = resultText.slice(0, linkStartIndex) + linkValue + resultText.slice(linkEndIndex);

            linkValueResult = linkRegex.exec(resultText);
            linkCloseTagResult = linkEndRegex.exec(resultText);
        }

        return resultText;
    };

    const cleanUpSpecificHTMLTags = (sourceText) => {
        if (!sourceText) {
            return '';
        }

        const processedSourceText = sourceText
            .replaceAll('</p>', '\r\n')
            .replaceAll('<span field=\'prospectFirstName\'>', '')
            .replaceAll('<span field=\'jobTitle\'>', '')
            .replaceAll('<span field=\'teName\'>', '')
            .replaceAll('<span field=\'teFirstName\'>', '')
            .replaceAll('<span field=\'teEmail\'>', '')
            .replaceAll('<span field=\'tePhone\'>', '')
            .replaceAll('<span field=\'employerName\'>', '')
            .replaceAll('<span field=\'location\'>', '')
            .replaceAll('</span>', '')
            .replaceAll('<br />', '\r\n')
            .replaceAll('<br>', '\r\n')
            .replaceAll('&nbsp;', ' ');

        return $(`<div>${processedSourceText}</div>`).text();
    };

    const changeTemplateTags = (templates, positionData, recruiterData, employerData) => _.forEach(templates, (template) => {
        const recruiterContactPhone = _.get(recruiterData, 'contact.phone[0].value', null);
        const recruiterContactEmail = Recruiter.getEmail(recruiterData);

        if (recruiterData) {
            template.template = template.template
                .replaceAll(
                    '<span field=\'teName\'></span>',
                    `<span field='teName'>${CommonCodeService.setStartCase(recruiterData.fullName)}</span>`,
                )
                .replaceAll(
                    '<span field=\'teFirstName\'></span>',
                    `<span field='teFirstName'>${CommonCodeService.setStartCaseAndGetFirst(recruiterData.fullName)}</span>`,
                );

            if (recruiterContactEmail) {
                template.template = template.template.replaceAll(
                    '<span field=\'teEmail\'></span>',
                    `<span field='teEmail'>${recruiterContactEmail}</span>`,
                );
            }

            if (recruiterContactPhone) {
                template.template = template.template.replaceAll(
                    '<span field=\'tePhone\'></span>',
                    `<span field='tePhone'>${recruiterContactPhone}</span>`,
                );
            }
        }


        if (positionData) {
            template.template = template.template
                .replaceAll(
                    '<span field=\'jobTitle\'></span>',
                    `<span field='jobTitle'>${CommonCodeService.setStartCase(positionData.jobTitle)}</span>`,
                )
                .replaceAll(
                    '<span field=\'employerName\'></span>',
                    `<span field='employerName'>${CommonCodeService.setStartCase(employerData.name)}</span>`,
                )
                .replaceAll(
                    '<a href=\'link\'>',
                    `<a href='${EnvSettings.Auth0RedirectUrl}#/insightReport/${positionData._id}'>`,
                )
                .replaceAll(
                    '<a href=\'scrapelink\'>',
                    `<a href='${EnvSettings.Auth0RedirectUrl}#/employer/${positionData.employerId}/job/${positionData._id}'>`,
                )
                .replaceAll(
                    '<a href=\'completeJobDefinitionLink\'>',
                    '<a href="link" replace-key="TARGET_LINK">',
                );
        }

        if (template.subject) {
            if (recruiterData) {
                template.subject = template.subject
                    .replaceAll(
                        '<span field=\'teName\'></span>',
                        `<span field='teName'>${CommonCodeService.setStartCase(recruiterData.fullName)}</span>`,
                    )
                    .replaceAll(
                        '<span field=\'teFirstName\'></span>',
                        `<span field='teFirstName'>${CommonCodeService.setStartCaseAndGetFirst(recruiterData.fullName)}</span>`,
                    );

                if (recruiterContactEmail) {
                    template.subject = template.subject.replaceAll(
                        '<span field=\'teEmail\'></span>',
                        `<span field='teEmail'>${recruiterContactEmail}</span>`,
                    );
                }

                if (recruiterContactPhone) {
                    template.subject = template.subject.replaceAll(
                        '<span field=\'tePhone\'></span>',
                        `<span field='tePhone'>${recruiterContactPhone}</span>`,
                    );
                }
            }

            if (positionData) {
                template.subject = template.subject
                    .replaceAll(
                        '<span field=\'jobTitle\'></span>',
                        `<span field='jobTitle'>${CommonCodeService.setStartCase(positionData.jobTitle)}</span>`,
                    )
                    .replaceAll(
                        '<span field=\'employerName\'></span>',
                        `<span field='employerName'>${CommonCodeService.setStartCase(employerData.name)}</span>`,
                    )
                    .replaceAll(
                        '<span field=\'location\'></span>',
                        `<span field='location'>${positionData.locationString}</span>`,
                    );
            }
        }
    });

    return {
        sendEmail,
        getPhoneFromContactData,
        getEmailDataFromRecruiterData,
        cleanUpSpecificHTMLTags,
        changeTemplateTags,
    };
}

angular.module('TALENYA-FE')
    .factory('EmailService', EmailService);
